export const serviceWorkerConstants = {
    SW_SET_STATE: "SW_SET_STATE",
};
